import * as Sentry from '@sentry/react';

export const setContext = (
  name: string,
  context: { [key: string]: any }
): void => {
  Sentry.setContext(name, context);
};
